import { Button, Form, Input, Modal, Row } from "antd";
import React, { useState } from "react";
import { useI18n } from "../../../i18n";
import { useGiveAccessToProject } from "../Project/api/api";

type InviteProps = {
  projectId: string;
  close: () => void;
};

export default function Invite({ projectId, close }: InviteProps) {
  const [t] = useI18n();
  const i18nKey = "library.inviteModal";
  const [email, setEmail] = useState("");
  const [inviteToProject] = useGiveAccessToProject();
  return (
    <Modal
      key={projectId}
      centered={true}
      width={"56.66em"}
      title={t(`${i18nKey}.title`)}
      open={projectId !== ""}
      onCancel={close}
      footer={null}>
      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={() => {
          inviteToProject({ variables: { projectId, userId: email } });
          close();
        }}
        layout="vertical">
        <Form.Item style={{ padding: "0 7em" }} label={t(`${i18nKey}.email`)} name="name">
          <Input value={email} onChange={(e) => setEmail(e.target.value)} />
        </Form.Item>
        <Form.Item style={{ margin: 0 }}>
          <Row justify="center">
            <Button disabled={email.length === 0} htmlType="submit" shape="round">
              {t(`${i18nKey}.invite`)}
            </Button>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
}
